(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ele-home-favorites"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ele-favorite-feedback')) {
    customElements.define('ele-favorite-feedback', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        const setStatus = (event, message, success) => {
          const card = event.target.closest('.ele-home-favorites__item');
          const status = card?.querySelector('.ele-home-favorites__status');
          if (!status) return;
          status.querySelector('span').textContent = message;
          status.querySelector('a').hidden = !success;
          status.hidden = false;
        };
        this.addEventListener('variant:add', event => setStatus(event, 'Tilføjet til kurven.', true), options);
        this.addEventListener('cart:error', event => setStatus(event, event.detail?.error || 'Varen kunne ikke lægges i kurven. Prøv igen.', false), options);
      }
      disconnectedCallback() { this.abortController?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ele-rebuy-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ele-rebuy-look')) {
    customElements.define('ele-rebuy-look', class extends HTMLElement {
      connectedCallback() {
        const updateHeading = () => {
          const widget = this.querySelector('#rebuy-widget-238552');
          const heading = widget?.querySelector('.primary-title');
          const grid = widget?.querySelector('.rebuy-product-grid');
          if (heading && heading.textContent !== this.dataset.heading) heading.textContent = this.dataset.heading;
          if (heading) heading.setAttribute('aria-level', '2');
          if (grid && grid.getAttribute('aria-label') !== this.dataset.heading) grid.setAttribute('aria-label', this.dataset.heading);
        };
        this.observer?.disconnect();
        this.observer = new MutationObserver(updateHeading);
        this.observer.observe(this, { childList: true, subtree: true, characterData: true });
        updateHeading();
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
